/**
 * Created by Mikhail Menshenin on 08.09.2025
 */

const WeeklyGoalsToolbarItem = function () {
    ToolbarItem.call(this, ToolbarItem.WEEKLY_GOALS);

    this.countdown = new cleverapps.CountDown(cleverapps.weeklyGoals.calcTimeLeft(), {
        permanent: true
    });

    this.enable();

    this.onChangeState();
    cleverapps.weeklyGoals.on("updatePoints", this.onChangeState.bind(this), this);
    cleverapps.weeklyGoals.on("changeDay", this.onChangeState.bind(this), this);
    cleverapps.weeklyGoals.on("updateProgress", this.onChangeState.bind(this), this);

    cleverapps.weeklyGoals.on("updateGoals", () => cleverapps.toolbar.updateItems(), this);
};

WeeklyGoalsToolbarItem.prototype = Object.create(ToolbarItem.prototype);
WeeklyGoalsToolbarItem.prototype.constructor = WeeklyGoalsToolbarItem;

WeeklyGoalsToolbarItem.prototype.onChangeState = function () {
    const currentDay = cleverapps.weeklyGoals.calcCurrentDay();

    const waiting = cleverapps.weeklyGoals.goals.slice(0, currentDay + 1).some((list) => list.some((weeklyGoal) => weeklyGoal.isRewardedAvailable()));
    if (waiting) {
        this.mark();
    } else {
        this.unmark();
    }

    this.countdown.resetTimeLeft(cleverapps.weeklyGoals.calcTimeLeft());
    this.countdown.nextSecond(Date.now());
};

WeeklyGoalsToolbarItem.prototype.isVisible = function () {
    return cleverapps.meta.getSelectedLocation().locationConfig.isMain && cleverapps.weeklyGoals.isAvailable();
};

WeeklyGoalsToolbarItem.prototype.onClick = function () {
    cleverapps.weeklyGoals.displayWindow();
};